import { Component, OnInit } from '@angular/core';
import {CompetenciaLocal} from '../competencia-local.model';
import {ActivatedRoute} from '@angular/router';
import {MensagemService, ProgressoService} from 'maestro-ng';
import {CompetenciaLocalService} from '../competencia-local.service';
import {Competencia} from '../../competencia/competencia.model';
import { FonteDados } from '../../fonte-dados/fonte-dados.model';

@Component({
  selector: 'app-competencia-local-visualizacao',
  templateUrl: './competencia-local-visualizacao.component.html',
  styleUrls: ['./competencia-local-visualizacao.component.css']
})
export class CompetenciaLocalVisualizacaoComponent implements OnInit {

  public static TAB_ORGAO_JULGADRO = 0;
  public competenciaLocal: CompetenciaLocal;
  public fonteDados: FonteDados;
  public tabViewIndex = CompetenciaLocalVisualizacaoComponent.TAB_ORGAO_JULGADRO;

  constructor(
    private route: ActivatedRoute,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private competenciaLocalService: CompetenciaLocalService,
  ) { }



  ngOnInit(): void {
    this.competenciaLocal = {} as Competencia;
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.progressoService.modal();
        this.competenciaLocalService.recuperarPorId(+params['id'])
          .then((competenciaLocal) => this.carregarCompetenciaLocal(competenciaLocal))
          .catch(response => this.mensagemService.addErro('Erro ao carregar competencia local.', response.error));
      }
    });

  }

  public onChangeTabView() {

    switch (this.tabViewIndex) {
      case CompetenciaLocalVisualizacaoComponent.TAB_ORGAO_JULGADRO:
        break;
    }
  }

  public carregarCompetenciaLocal(competenciaLocal: CompetenciaLocal) {
    this.competenciaLocal = competenciaLocal;
    this.fonteDados = competenciaLocal.fonteDados;
    this.progressoService.fechar();
  }

  sincronizarPorId(): void {
    this.progressoService.modal();
    this.competenciaLocalService.sincronizarPorId(this.competenciaLocal.id)
      .then(() => {
        this.mensagemService.addSucesso('Resultado', 'Sincronização concluída com sucesso');
        this.ngOnInit();
        this.progressoService.fechar();
      }).catch(resposta => {
      this.mensagemService.addErro(`Erro ao recuperar sincronizar a competencia: ${this.competenciaLocal.id} `, resposta.error);
      this.progressoService.fechar();
    });
  }

}
